import React from 'react';
import './Button.css';

/**
 * Bouton unifié (tokens --bt-* / variables Button.css).
 * Utiliser `as` pour NavLink : <Button as={NavLink} to="/x" variant="primary">…</Button>
 */
function Button({
  children,
  variant = 'secondary',
  size = 'md',
  loading = false,
  disabled = false,
  className = '',
  type = 'button',
  as: Component = 'button',
  ...rest
}) {
  const classes = [
    'bt-btn',
    `bt-btn--${variant}`,
    `bt-btn--${size}`,
    loading ? 'bt-btn--loading' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  const isDisabled = disabled || loading;

  if (Component !== 'button') {
    return (
      <Component
        className={classes}
        aria-busy={loading || undefined}
        aria-disabled={isDisabled ? true : undefined}
        {...rest}
      >
        {loading ? <span className="bt-btn__spinner" aria-hidden /> : null}
        <span className="bt-btn__inner">{children}</span>
      </Component>
    );
  }

  return (
    <button
      type={type}
      className={classes}
      disabled={isDisabled}
      aria-busy={loading || undefined}
      {...rest}
    >
      {loading ? <span className="bt-btn__spinner" aria-hidden /> : null}
      <span className="bt-btn__inner">{children}</span>
    </button>
  );
}

export default Button;
